/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { BatchUpdateResponse } from '../models/batch-update-response';
import { FindMaintenanceRegistryPerTicketResponse } from '../models/find-maintenance-registry-per-ticket-response';
import { NextStatesResponse } from '../models/next-states-response';
import { PreviousStatesResponse } from '../models/previous-states-response';
import { StringItem } from '../models/string-item';
import { ticketControllerAppendNote } from '../fn/ticket/ticket-controller-append-note';
import { TicketControllerAppendNote$Params } from '../fn/ticket/ticket-controller-append-note';
import { ticketControllerBatchChangeTicketStatus } from '../fn/ticket/ticket-controller-batch-change-ticket-status';
import { TicketControllerBatchChangeTicketStatus$Params } from '../fn/ticket/ticket-controller-batch-change-ticket-status';
import { ticketControllerChangeTicketStatus } from '../fn/ticket/ticket-controller-change-ticket-status';
import { TicketControllerChangeTicketStatus$Params } from '../fn/ticket/ticket-controller-change-ticket-status';
import { ticketControllerCorrectTicketStatus } from '../fn/ticket/ticket-controller-correct-ticket-status';
import { TicketControllerCorrectTicketStatus$Params } from '../fn/ticket/ticket-controller-correct-ticket-status';
import { ticketControllerCreate } from '../fn/ticket/ticket-controller-create';
import { TicketControllerCreate$Params } from '../fn/ticket/ticket-controller-create';
import { ticketControllerCreateExternalTicket } from '../fn/ticket/ticket-controller-create-external-ticket';
import { TicketControllerCreateExternalTicket$Params } from '../fn/ticket/ticket-controller-create-external-ticket';
import { ticketControllerCreateExternalTicketWithoutSerialNumber } from '../fn/ticket/ticket-controller-create-external-ticket-without-serial-number';
import { TicketControllerCreateExternalTicketWithoutSerialNumber$Params } from '../fn/ticket/ticket-controller-create-external-ticket-without-serial-number';
import { ticketControllerCreateIntegrationNote } from '../fn/ticket/ticket-controller-create-integration-note';
import { TicketControllerCreateIntegrationNote$Params } from '../fn/ticket/ticket-controller-create-integration-note';
import { ticketControllerCreateTicketTag } from '../fn/ticket/ticket-controller-create-ticket-tag';
import { TicketControllerCreateTicketTag$Params } from '../fn/ticket/ticket-controller-create-ticket-tag';
import { ticketControllerCreateTicketWithoutSerialNumber } from '../fn/ticket/ticket-controller-create-ticket-without-serial-number';
import { TicketControllerCreateTicketWithoutSerialNumber$Params } from '../fn/ticket/ticket-controller-create-ticket-without-serial-number';
import { ticketControllerDelete } from '../fn/ticket/ticket-controller-delete';
import { TicketControllerDelete$Params } from '../fn/ticket/ticket-controller-delete';
import { ticketControllerDeleteTicketTag } from '../fn/ticket/ticket-controller-delete-ticket-tag';
import { TicketControllerDeleteTicketTag$Params } from '../fn/ticket/ticket-controller-delete-ticket-tag';
import { ticketControllerDownloadOne } from '../fn/ticket/ticket-controller-download-one';
import { TicketControllerDownloadOne$Params } from '../fn/ticket/ticket-controller-download-one';
import { ticketControllerFindAll } from '../fn/ticket/ticket-controller-find-all';
import { TicketControllerFindAll$Params } from '../fn/ticket/ticket-controller-find-all';
import { ticketControllerFindAllTicketType } from '../fn/ticket/ticket-controller-find-all-ticket-type';
import { TicketControllerFindAllTicketType$Params } from '../fn/ticket/ticket-controller-find-all-ticket-type';
import { ticketControllerFindByIds } from '../fn/ticket/ticket-controller-find-by-ids';
import { TicketControllerFindByIds$Params } from '../fn/ticket/ticket-controller-find-by-ids';
import { ticketControllerFindByIdsWithAsset } from '../fn/ticket/ticket-controller-find-by-ids-with-asset';
import { TicketControllerFindByIdsWithAsset$Params } from '../fn/ticket/ticket-controller-find-by-ids-with-asset';
import { ticketControllerFindIntegrationNotes } from '../fn/ticket/ticket-controller-find-integration-notes';
import { TicketControllerFindIntegrationNotes$Params } from '../fn/ticket/ticket-controller-find-integration-notes';
import { ticketControllerFindMaintenanceRegistryPerTicket } from '../fn/ticket/ticket-controller-find-maintenance-registry-per-ticket';
import { TicketControllerFindMaintenanceRegistryPerTicket$Params } from '../fn/ticket/ticket-controller-find-maintenance-registry-per-ticket';
import { ticketControllerFindOne } from '../fn/ticket/ticket-controller-find-one';
import { TicketControllerFindOne$Params } from '../fn/ticket/ticket-controller-find-one';
import { ticketControllerFindTicketNodes } from '../fn/ticket/ticket-controller-find-ticket-nodes';
import { TicketControllerFindTicketNodes$Params } from '../fn/ticket/ticket-controller-find-ticket-nodes';
import { ticketControllerFindTicketPreviousStatuses } from '../fn/ticket/ticket-controller-find-ticket-previous-statuses';
import { TicketControllerFindTicketPreviousStatuses$Params } from '../fn/ticket/ticket-controller-find-ticket-previous-statuses';
import { ticketControllerFindTicketTag } from '../fn/ticket/ticket-controller-find-ticket-tag';
import { TicketControllerFindTicketTag$Params } from '../fn/ticket/ticket-controller-find-ticket-tag';
import { ticketControllerGetTicketSlaSummary } from '../fn/ticket/ticket-controller-get-ticket-sla-summary';
import { TicketControllerGetTicketSlaSummary$Params } from '../fn/ticket/ticket-controller-get-ticket-sla-summary';
import { ticketControllerPreviewBody } from '../fn/ticket/ticket-controller-preview-body';
import { TicketControllerPreviewBody$Params } from '../fn/ticket/ticket-controller-preview-body';
import { ticketControllerSendEmail } from '../fn/ticket/ticket-controller-send-email';
import { TicketControllerSendEmail$Params } from '../fn/ticket/ticket-controller-send-email';
import { ticketControllerUpdate } from '../fn/ticket/ticket-controller-update';
import { TicketControllerUpdate$Params } from '../fn/ticket/ticket-controller-update';
import { ticketControllerUpdateTicketTag } from '../fn/ticket/ticket-controller-update-ticket-tag';
import { TicketControllerUpdateTicketTag$Params } from '../fn/ticket/ticket-controller-update-ticket-tag';
import { ticketControllerUpdateTicketWithouSerialNumber } from '../fn/ticket/ticket-controller-update-ticket-withou-serial-number';
import { TicketControllerUpdateTicketWithouSerialNumber$Params } from '../fn/ticket/ticket-controller-update-ticket-withou-serial-number';
import { TicketIntegrationNoteItem } from '../models/ticket-integration-note-item';
import { TicketIntegrationNotesResponse } from '../models/ticket-integration-notes-response';
import { TicketItem } from '../models/ticket-item';
import { ticketLockControllerAcquire } from '../fn/ticket/ticket-lock-controller-acquire';
import { TicketLockControllerAcquire$Params } from '../fn/ticket/ticket-lock-controller-acquire';
import { ticketLockControllerForce } from '../fn/ticket/ticket-lock-controller-force';
import { TicketLockControllerForce$Params } from '../fn/ticket/ticket-lock-controller-force';
import { ticketLockControllerRelease } from '../fn/ticket/ticket-lock-controller-release';
import { TicketLockControllerRelease$Params } from '../fn/ticket/ticket-lock-controller-release';
import { TicketLockItem } from '../models/ticket-lock-item';
import { TicketResponse } from '../models/ticket-response';
import { TicketSlaSummaryResponse } from '../models/ticket-sla-summary-response';
import { TicketTagItem } from '../models/ticket-tag-item';
import { TicketTagResponse } from '../models/ticket-tag-response';
import { TicketTypeResponse } from '../models/ticket-type-response';

@Injectable({ providedIn: 'root' })
export class TicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ticketControllerFindAll()` */
  static readonly TicketControllerFindAllPath = '/ticket';

  /**
   * Restituisce la lista dei ticket padri con array di subticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindAll$Response(params: TicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketResponse;
}>> {
    return ticketControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la lista dei ticket padri con array di subticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindAll(params: TicketControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketResponse;
}> {
    return this.ticketControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketResponse;
}>): BaseResponse & {
'data'?: TicketResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreate()` */
  static readonly TicketControllerCreatePath = '/ticket';

  /**
   * Crea un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreate$Response(params: TicketControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreate(params: TicketControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreateTicketWithoutSerialNumber()` */
  static readonly TicketControllerCreateTicketWithoutSerialNumberPath = '/ticket/create-ticket-without-serial';

  /**
   * Crea un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreateTicketWithoutSerialNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateTicketWithoutSerialNumber$Response(params: TicketControllerCreateTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
    return ticketControllerCreateTicketWithoutSerialNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreateTicketWithoutSerialNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateTicketWithoutSerialNumber(params: TicketControllerCreateTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketItem;
}> {
    return this.ticketControllerCreateTicketWithoutSerialNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>): BaseResponse & {
'data'?: TicketItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindTicketTag()` */
  static readonly TicketControllerFindTicketTagPath = '/ticket/tag';

  /**
   * Lista ticket tag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindTicketTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketTag$Response(params: TicketControllerFindTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagResponse;
}>> {
    return ticketControllerFindTicketTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista ticket tag.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindTicketTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketTag(params: TicketControllerFindTicketTag$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketTagResponse;
}> {
    return this.ticketControllerFindTicketTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketTagResponse;
}>): BaseResponse & {
'data'?: TicketTagResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreateTicketTag()` */
  static readonly TicketControllerCreateTicketTagPath = '/ticket/tag';

  /**
   * Crea un tag ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreateTicketTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateTicketTag$Response(params: TicketControllerCreateTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>> {
    return ticketControllerCreateTicketTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un tag ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreateTicketTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateTicketTag(params: TicketControllerCreateTicketTag$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketTagItem;
}> {
    return this.ticketControllerCreateTicketTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>): BaseResponse & {
'data'?: TicketTagItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerGetTicketSlaSummary()` */
  static readonly TicketControllerGetTicketSlaSummaryPath = '/ticket/ticket-sla-summary';

  /**
   * Restituisce il conteggio dei ticket scaduti, attivi e totali.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerGetTicketSlaSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerGetTicketSlaSummary$Response(params?: TicketControllerGetTicketSlaSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketSlaSummaryResponse;
}>> {
    return ticketControllerGetTicketSlaSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il conteggio dei ticket scaduti, attivi e totali.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerGetTicketSlaSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerGetTicketSlaSummary(params?: TicketControllerGetTicketSlaSummary$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketSlaSummaryResponse;
}> {
    return this.ticketControllerGetTicketSlaSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketSlaSummaryResponse;
}>): BaseResponse & {
'data'?: TicketSlaSummaryResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindTicketNodes()` */
  static readonly TicketControllerFindTicketNodesPath = '/ticket/nodes/{id}';

  /**
   * Restituisce gli stati successivi del ticket disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindTicketNodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketNodes$Response(params: TicketControllerFindTicketNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>> {
    return ticketControllerFindTicketNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati successivi del ticket disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindTicketNodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketNodes(params: TicketControllerFindTicketNodes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NextStatesResponse;
}> {
    return this.ticketControllerFindTicketNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>): BaseResponse & {
'data'?: NextStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindTicketPreviousStatuses()` */
  static readonly TicketControllerFindTicketPreviousStatusesPath = '/ticket/previous-nodes/{id}';

  /**
   * Restituisce gli stati precedenti del ticket nel workflow, per correggere un errore di assegnazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindTicketPreviousStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketPreviousStatuses$Response(params: TicketControllerFindTicketPreviousStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PreviousStatesResponse;
}>> {
    return ticketControllerFindTicketPreviousStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati precedenti del ticket nel workflow, per correggere un errore di assegnazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindTicketPreviousStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindTicketPreviousStatuses(params: TicketControllerFindTicketPreviousStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PreviousStatesResponse;
}> {
    return this.ticketControllerFindTicketPreviousStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PreviousStatesResponse;
}>): BaseResponse & {
'data'?: PreviousStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindMaintenanceRegistryPerTicket()` */
  static readonly TicketControllerFindMaintenanceRegistryPerTicketPath = '/ticket/find-maintenance-registry-per-ticket/{id}';

  /**
   * Restituisce le aziende correlate che abbiano schedulazioni assegnate relative al ticket passato. Si escludono le schedulazioni in stato "Annullata".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindMaintenanceRegistryPerTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindMaintenanceRegistryPerTicket$Response(params: TicketControllerFindMaintenanceRegistryPerTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FindMaintenanceRegistryPerTicketResponse;
}>> {
    return ticketControllerFindMaintenanceRegistryPerTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le aziende correlate che abbiano schedulazioni assegnate relative al ticket passato. Si escludono le schedulazioni in stato "Annullata".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindMaintenanceRegistryPerTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindMaintenanceRegistryPerTicket(params: TicketControllerFindMaintenanceRegistryPerTicket$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FindMaintenanceRegistryPerTicketResponse;
}> {
    return this.ticketControllerFindMaintenanceRegistryPerTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FindMaintenanceRegistryPerTicketResponse;
}>): BaseResponse & {
'data'?: FindMaintenanceRegistryPerTicketResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindAllTicketType()` */
  static readonly TicketControllerFindAllTicketTypePath = '/ticket/ticket-type';

  /**
   * Restituisce i tipi dei ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindAllTicketType()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindAllTicketType$Response(params?: TicketControllerFindAllTicketType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTypeResponse;
}>> {
    return ticketControllerFindAllTicketType(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i tipi dei ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindAllTicketType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindAllTicketType(params?: TicketControllerFindAllTicketType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketTypeResponse;
}> {
    return this.ticketControllerFindAllTicketType$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketTypeResponse;
}>): BaseResponse & {
'data'?: TicketTypeResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerDeleteTicketTag()` */
  static readonly TicketControllerDeleteTicketTagPath = '/ticket/tag/{id}';

  /**
   * Delete tag ticket.
   *
   * Rimuove un tag ticket
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerDeleteTicketTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDeleteTicketTag$Response(params: TicketControllerDeleteTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>> {
    return ticketControllerDeleteTicketTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete tag ticket.
   *
   * Rimuove un tag ticket
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerDeleteTicketTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDeleteTicketTag(params: TicketControllerDeleteTicketTag$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketTagItem;
}> {
    return this.ticketControllerDeleteTicketTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>): BaseResponse & {
'data'?: TicketTagItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerUpdateTicketTag()` */
  static readonly TicketControllerUpdateTicketTagPath = '/ticket/tag/{id}';

  /**
   * Aggiorna un tag ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerUpdateTicketTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdateTicketTag$Response(params: TicketControllerUpdateTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>> {
    return ticketControllerUpdateTicketTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna un tag ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerUpdateTicketTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdateTicketTag(params: TicketControllerUpdateTicketTag$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketTagItem;
}> {
    return this.ticketControllerUpdateTicketTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>): BaseResponse & {
'data'?: TicketTagItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerBatchChangeTicketStatus()` */
  static readonly TicketControllerBatchChangeTicketStatusPath = '/ticket/batch/change-status';

  /**
   * Cambio stato massivo ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerBatchChangeTicketStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerBatchChangeTicketStatus$Response(params: TicketControllerBatchChangeTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>> {
    return ticketControllerBatchChangeTicketStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambio stato massivo ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerBatchChangeTicketStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerBatchChangeTicketStatus(params: TicketControllerBatchChangeTicketStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BatchUpdateResponse;
}> {
    return this.ticketControllerBatchChangeTicketStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>): BaseResponse & {
'data'?: BatchUpdateResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerChangeTicketStatus()` */
  static readonly TicketControllerChangeTicketStatusPath = '/ticket/change-ticket-status/{id}';

  /**
   * Modifica lo stato di un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerChangeTicketStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerChangeTicketStatus$Response(params: TicketControllerChangeTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
    return ticketControllerChangeTicketStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica lo stato di un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerChangeTicketStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerChangeTicketStatus(params: TicketControllerChangeTicketStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketItem;
}> {
    return this.ticketControllerChangeTicketStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>): BaseResponse & {
'data'?: TicketItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCorrectTicketStatus()` */
  static readonly TicketControllerCorrectTicketStatusPath = '/ticket/correct-ticket-status/{id}';

  /**
   * Corregge lo stato di un ticket riportandolo a uno stato precedente del workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCorrectTicketStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCorrectTicketStatus$Response(params: TicketControllerCorrectTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
    return ticketControllerCorrectTicketStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Corregge lo stato di un ticket riportandolo a uno stato precedente del workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCorrectTicketStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCorrectTicketStatus(params: TicketControllerCorrectTicketStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketItem;
}> {
    return this.ticketControllerCorrectTicketStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>): BaseResponse & {
'data'?: TicketItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindOne()` */
  static readonly TicketControllerFindOnePath = '/ticket/{id}';

  /**
   * Restituisce un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindOne$Response(params: TicketControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
    return ticketControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindOne(params: TicketControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketItem;
}> {
    return this.ticketControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>): BaseResponse & {
'data'?: TicketItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerDelete()` */
  static readonly TicketControllerDeletePath = '/ticket/{id}';

  /**
   * Cancella ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDelete$Response(params: TicketControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancella ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDelete(params: TicketControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerUpdate()` */
  static readonly TicketControllerUpdatePath = '/ticket/{id}';

  /**
   * Modifica un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdate$Response(params: TicketControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdate(params: TicketControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerUpdateTicketWithouSerialNumber()` */
  static readonly TicketControllerUpdateTicketWithouSerialNumberPath = '/ticket/update-ticket-without-serial/{id}';

  /**
   * Modifica un ticket senza seriale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerUpdateTicketWithouSerialNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdateTicketWithouSerialNumber$Response(params: TicketControllerUpdateTicketWithouSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerUpdateTicketWithouSerialNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un ticket senza seriale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerUpdateTicketWithouSerialNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerUpdateTicketWithouSerialNumber(params: TicketControllerUpdateTicketWithouSerialNumber$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerUpdateTicketWithouSerialNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindIntegrationNotes()` */
  static readonly TicketControllerFindIntegrationNotesPath = '/ticket/{id}/integration-notes';

  /**
   * Note per le integrazioni di un ticket, con filtri (solo ticket di commesse con le note abilitate).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindIntegrationNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindIntegrationNotes$Response(params: TicketControllerFindIntegrationNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNotesResponse;
}>> {
    return ticketControllerFindIntegrationNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * Note per le integrazioni di un ticket, con filtri (solo ticket di commesse con le note abilitate).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindIntegrationNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerFindIntegrationNotes(params: TicketControllerFindIntegrationNotes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketIntegrationNotesResponse;
}> {
    return this.ticketControllerFindIntegrationNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNotesResponse;
}>): BaseResponse & {
'data'?: TicketIntegrationNotesResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreateIntegrationNote()` */
  static readonly TicketControllerCreateIntegrationNotePath = '/ticket/{id}/integration-notes';

  /**
   * Aggiunge una nota per le integrazioni a un ticket non chiuso né annullato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreateIntegrationNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateIntegrationNote$Response(params: TicketControllerCreateIntegrationNote$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNoteItem;
}>> {
    return ticketControllerCreateIntegrationNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una nota per le integrazioni a un ticket non chiuso né annullato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreateIntegrationNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateIntegrationNote(params: TicketControllerCreateIntegrationNote$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketIntegrationNoteItem;
}> {
    return this.ticketControllerCreateIntegrationNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNoteItem;
}>): BaseResponse & {
'data'?: TicketIntegrationNoteItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreateExternalTicket()` */
  static readonly TicketControllerCreateExternalTicketPath = '/ticket/external-ticket';

  /**
   * Crea un ticket esterno (integrazione).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreateExternalTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateExternalTicket$Response(params: TicketControllerCreateExternalTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerCreateExternalTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ticket esterno (integrazione).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreateExternalTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateExternalTicket(params: TicketControllerCreateExternalTicket$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerCreateExternalTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerCreateExternalTicketWithoutSerialNumber()` */
  static readonly TicketControllerCreateExternalTicketWithoutSerialNumberPath = '/ticket/external-ticket-without-serial';

  /**
   * Crea un ticket esterno senza seriale (integrazione).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerCreateExternalTicketWithoutSerialNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateExternalTicketWithoutSerialNumber$Response(params: TicketControllerCreateExternalTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerCreateExternalTicketWithoutSerialNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ticket esterno senza seriale (integrazione).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerCreateExternalTicketWithoutSerialNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerCreateExternalTicketWithoutSerialNumber(params: TicketControllerCreateExternalTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerCreateExternalTicketWithoutSerialNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindByIds()` */
  static readonly TicketControllerFindByIdsPath = '/ticket/by-ids';

  /**
   * Restituisce ticket specifici per ID ticket (integrazione).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindByIds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerFindByIds$Response(params: TicketControllerFindByIds$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerFindByIds(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce ticket specifici per ID ticket (integrazione).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindByIds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerFindByIds(params: TicketControllerFindByIds$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerFindByIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerFindByIdsWithAsset()` */
  static readonly TicketControllerFindByIdsWithAssetPath = '/ticket/by-ids-with-asset';

  /**
   * Restituisce ticket specifici per ID ticket con dati asset (integrazione).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerFindByIdsWithAsset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerFindByIdsWithAsset$Response(params: TicketControllerFindByIdsWithAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerFindByIdsWithAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce ticket specifici per ID ticket con dati asset (integrazione).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerFindByIdsWithAsset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerFindByIdsWithAsset(params: TicketControllerFindByIdsWithAsset$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerFindByIdsWithAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerAppendNote()` */
  static readonly TicketControllerAppendNotePath = '/ticket/note';

  /**
   * Appende una nota a un ticket (integrazione).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerAppendNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerAppendNote$Response(params: TicketControllerAppendNote$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerAppendNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Appende una nota a un ticket (integrazione).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerAppendNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerAppendNote(params: TicketControllerAppendNote$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerAppendNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerDownloadOne()` */
  static readonly TicketControllerDownloadOnePath = '/ticket/{id}/download';

  /**
   * Restituisce il pdf di un ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerDownloadOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDownloadOne$Response(params: TicketControllerDownloadOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return ticketControllerDownloadOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il pdf di un ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerDownloadOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerDownloadOne(params: TicketControllerDownloadOne$Params, context?: HttpContext): Observable<Blob> {
    return this.ticketControllerDownloadOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `ticketControllerPreviewBody()` */
  static readonly TicketControllerPreviewBodyPath = '/ticket/{id}/preview-body';

  /**
   * Anteprima body email per il ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerPreviewBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerPreviewBody$Response(params: TicketControllerPreviewBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return ticketControllerPreviewBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Anteprima body email per il ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerPreviewBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketControllerPreviewBody(params: TicketControllerPreviewBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.ticketControllerPreviewBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketControllerSendEmail()` */
  static readonly TicketControllerSendEmailPath = '/ticket/{id}/send-email';

  /**
   * Invia email per il ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerSendEmail$Response(params: TicketControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
    return ticketControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia email per il ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketControllerSendEmail(params: TicketControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BaseResponse;
}> {
    return this.ticketControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>): BaseResponse & {
'data'?: BaseResponse;
} => r.body)
    );
  }

  /** Path part for operation `ticketLockControllerAcquire()` */
  static readonly TicketLockControllerAcquirePath = '/ticket/{id}/lock';

  /**
   * Acquisisce o rinnova il blocco di modifica del ticket. Se è di un altro restituisce acquired=false e chi lo tiene.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketLockControllerAcquire()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerAcquire$Response(params: TicketLockControllerAcquire$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>> {
    return ticketLockControllerAcquire(this.http, this.rootUrl, params, context);
  }

  /**
   * Acquisisce o rinnova il blocco di modifica del ticket. Se è di un altro restituisce acquired=false e chi lo tiene.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketLockControllerAcquire$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerAcquire(params: TicketLockControllerAcquire$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketLockItem;
}> {
    return this.ticketLockControllerAcquire$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>): BaseResponse & {
'data'?: TicketLockItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketLockControllerRelease()` */
  static readonly TicketLockControllerReleasePath = '/ticket/{id}/unlock';

  /**
   * Rilascia il blocco di modifica del ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketLockControllerRelease()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerRelease$Response(params: TicketLockControllerRelease$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>> {
    return ticketLockControllerRelease(this.http, this.rootUrl, params, context);
  }

  /**
   * Rilascia il blocco di modifica del ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketLockControllerRelease$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerRelease(params: TicketLockControllerRelease$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketLockItem;
}> {
    return this.ticketLockControllerRelease$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>): BaseResponse & {
'data'?: TicketLockItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketLockControllerForce()` */
  static readonly TicketLockControllerForcePath = '/ticket/{id}/lock/force';

  /**
   * Forza lo sblocco: prende il blocco di modifica anche se è di un altro utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketLockControllerForce()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerForce$Response(params: TicketLockControllerForce$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>> {
    return ticketLockControllerForce(this.http, this.rootUrl, params, context);
  }

  /**
   * Forza lo sblocco: prende il blocco di modifica anche se è di un altro utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketLockControllerForce$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketLockControllerForce(params: TicketLockControllerForce$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketLockItem;
}> {
    return this.ticketLockControllerForce$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>): BaseResponse & {
'data'?: TicketLockItem;
} => r.body)
    );
  }

}
